import * as React from 'react'
import { Modal } from '@doordash/component-modal'
import { InlineChildren } from '@doordash/design-language'
import CvcCard from '../images/cvc-card'

import t from './strings'

type Props = {
  onClose: (e: React.MouseEvent<HTMLElement>) => void
}

export const CvcModal: React.FC<Props> = props => (
  <Modal
    title={t.cvcModal__title()}
    primaryAction={{
      text: t.cvcModal__primaryAction(),
      onClick: props.onClose,
    }}
    actionsFillContainer
    size={Modal.Sizes.Medium}
    isFullScreenOnMobile={false}
    {...props}
  >
    <InlineChildren justifyContent={InlineChildren.Justification.Center}>
      <CvcCard width={270} height={198} />
    </InlineChildren>
  </Modal>
)

export default CvcModal
